module.exports = __webpack_public_path__ + "static/media/event-01.79ab74cc.jpg";